"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PriceDisplay = function PriceDisplay(props) {
  if (parseFloat(props.price) <= 0) {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    style: _objectSpread({
      fontSize: '16px',
      fontWeight: 'bold'
    }, props.style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-6",
    style: _objectSpread({}, props.labelStyle)
  }, props.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-sm-6",
    style: _objectSpread({}, props.priceStyle)
  }, "$", props.price));
};

var _default = PriceDisplay;
exports["default"] = _default;